import { io, Socket } from 'socket.io-client';

import useMaintenanceStore from '@/store/useMaintenanceStore';
import useUser from '@/store/useUser';

const WS_URL = import.meta.env.VITE_APP_WS_ENDPOINT as string;

let socket: Socket | null = null;

export function connectWebSocket() {
  const token = useUser.getState().user.token;
  if (!token) return;

  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }

  socket = io(WS_URL, {
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    transports: ['websocket'],
    auth: { token },
  });

  socket.on('connect', () => {
    useMaintenanceStore.getState().setConnected();

    if (socket?.connected) {
      socket.emit('get_maintenance_mode');
    }
  });

  socket.on('maintenance_mode', (data) => {
    if (typeof data?.maintenance_mode === 'boolean') {
      useMaintenanceStore.getState().setMaintenanceMode(data.maintenance_mode);
    }
  });

  socket.on('disconnect', () => {
    useMaintenanceStore.getState().setDisconnected();
  });

  socket.on('connect_error', (err) => {
    console.error('Socket error:', err.message);
    useMaintenanceStore.getState().setDisconnected();

    if (err.message === 'Unauthorized') {
      socket?.disconnect();
      socket = null;
    }
  });

  socket.io.on('reconnect', () => {
    useMaintenanceStore.getState().setConnected();

    if (socket?.connected) {
      socket.emit('get_maintenance_mode');
    }
  });

  socket.io.on('reconnect_attempt', (attempt) => {
    console.log('Reconnect attempt:', attempt);
  });

  socket.io.on('reconnect_failed', () => {
    useMaintenanceStore.getState().setDisconnected();
  });
}

export function disconnectWebSocket() {
  socket?.disconnect();
  socket = null;
}
